import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../components/Spinner";
//
const EditProduct = () => {
  const [local, setLocal] = useState("");
  const [priceInCents, setPriceInCents] = useState("");
  const [tags, setTags] = useState("");
  const [evento, setEvento] = useState("");
  const [loading, setLoading] = useState(false);
  const [atletas, setAtletas] = useState([]);
  const [filteredAtletas, setFilteredAtletas] = useState([]);
  const [selectedAtletas, setSelectedAtletas] = useState([]); // Array de atletas selecionados
  const [searchTerm, setSearchTerm] = useState("");
  const [image, setImage] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const token = localStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    setLoading(true);

    const loadData = async () => {
      try {
        const [atletasRes, prodRes] = await Promise.all([
          axios.get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`, config),
          axios.get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`),
        ]);

        const allAtletas = atletasRes.data?.data || [];
        setAtletas(allAtletas);
        setFilteredAtletas(allAtletas);

        const prod = prodRes.data;
        setImage(prod.imageSample);
        setLocal(prod.local || "");
        setPriceInCents(prod.priceInCents || "");
        setTags(prod.tags || "");
        setEvento(prod.evento || "");

        // Carrega atletas vinculados
        if (Array.isArray(prod.atletas) && prod.atletas.length > 0) {
          const preSelected = prod.atletas.map((a) => {
            const found = allAtletas.find((x) => x._id === (a.atletaId || a._id));
            return {
              _id: a.atletaId || a._id,
              nome: a.atletaNome || found?.nome || "Atleta",
            };
          });
          setSelectedAtletas(preSelected);
        } else if (Array.isArray(prod.atletasIds) && prod.atletasIds.length > 0) {
          const preSelected = prod.atletasIds.map((aId) => {
            const found = allAtletas.find((x) => x._id === aId);
            return found ? { _id: found._id, nome: found.nome } : { _id: aId, nome: "Atleta" };
          });
          setSelectedAtletas(preSelected);
        } else if (prod.atletaId) {
          const found = allAtletas.find((x) => x._id === prod.atletaId);
          setSelectedAtletas([
            {
              _id: prod.atletaId,
              nome: prod.atletaNome || found?.nome || "Atleta",
            },
          ]);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(error);
        enqueueSnackbar("Erro ao carregar dados do produto", { variant: "error" });
      }
    };

    loadData();
  }, [id]);

  // Função de busca dos atletas
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);

    const filtered = atletas
      .filter((atleta) => atleta.nome.toLowerCase().includes(query))
      .sort((a, b) => a.nome.localeCompare(b.nome));

    setFilteredAtletas(filtered);
  };

  const handleToggleAtleta = (atleta) => {
    setSelectedAtletas((prev) => {
      const exists = prev.some((a) => a._id === atleta._id);
      if (exists) {
        return prev.filter((a) => a._id !== atleta._id);
      } else {
        return [...prev, { _id: atleta._id, nome: atleta.nome }];
      }
    });
  };

  // Função para editar o produto
  const handleEditProduct = () => {
    const atletaIds = selectedAtletas.map((a) => a._id);
    const atletaNomes = selectedAtletas.map((a) => a.nome).join(", ");
    const atletasList = selectedAtletas.map((a) => ({
      atletaId: a._id,
      atletaNome: a.nome,
    }));

    const data = {
      local,
      priceInCents,
      tags,
      evento,
      atletaId: atletaIds[0] || "",
      atletaNome: atletaNomes || "",
      atletasIds: atletaIds,
      atletas: atletasList,
    };

    setLoading(true);
    axios
      .put(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`,
        data,
        config
      )
      .then(() => {
        setLoading(false);
        enqueueSnackbar("Produto atualizado com sucesso.", { variant: "success" });
        navigate("/admin");
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar("Não foi possível atualizar", { variant: "error" });
        console.log(error);
      });
  };

  return (
    <div className="p-6 bg-base-100 grid lg:space-x-4 justify-center items-start mt-16 lg:flex">
      {loading && <Spinner />}
      <div className="container max-w-lg shadow-lg rounded-lg p-5 bg-base-200">
        <Link
          to="/admin"
          className="flex justify-center items-center btn mb-4 w-12 py-2 px-4 text-sm rounded-xl"
        >
          Voltar
        </Link>
        <h1 className="text-3xl font-semibold my-4 ">Editar Produto</h1>
        <div className="my-4">
          <label htmlFor="local" className="block text-md mb-2">
            Local
          </label>
          <input
            id="local"
            type="text"
            value={local}
            onChange={(e) => setLocal(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="priceInCents" className="block text-md mb-2">
            Preço em centavos
          </label>
          <input
            id="priceInCents"
            type="number"
            value={priceInCents}
            onChange={(e) => setPriceInCents(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="tags" className="block text-md mb-2">
            Tags
          </label>
          <input
            id="tags"
            type="text"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="evento" className="block text-lg mb-2 mt-4">
            Evento
          </label>
          <input
            id="evento"
            type="text"
            value={evento}
            onChange={(e) => setEvento(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          {/* Campo de seleção de Atletas com filtro múltiplo */}
          <div className="mt-4 border border-base-300 rounded-md p-3 bg-base-200/40">
            <label className="block text-md font-medium mb-1">
              Atletas na foto <span className="text-xs font-normal opacity-70">(pode selecionar mais de um)</span>
            </label>
            <p className="text-xs opacity-75 mb-2">
              Marque as pessoas que aparecem nesta foto.
            </p>

            {selectedAtletas.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mb-2">
                {selectedAtletas.map((a) => (
                  <span
                    key={a._id}
                    className="badge badge-primary gap-1 py-3 px-2 text-xs"
                  >
                    {a.nome}
                    <button
                      type="button"
                      onClick={() => handleToggleAtleta(a)}
                      className="hover:text-red-300 ml-1 font-bold"
                      title="Remover"
                    >
                      ✕
                    </button>
                  </span>
                ))}
              </div>
            )}

            <input
              id="atleta-search"
              type="text"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Buscar atleta para marcar..."
              className="border border-base-300 px-3 py-1.5 w-full rounded-md text-sm mb-2 bg-base-100"
            />

            <div className="max-h-40 overflow-y-auto border border-base-300 rounded-md p-2 bg-base-100 divide-y divide-base-200">
              {filteredAtletas.length > 0 ? (
                filteredAtletas.map((atleta) => {
                  const isChecked = selectedAtletas.some(
                    (a) => a._id === atleta._id
                  );
                  return (
                    <label
                      key={atleta._id}
                      className="flex items-center gap-2 py-1.5 px-1 hover:bg-base-200 rounded cursor-pointer text-sm"
                    >
                      <input
                        type="checkbox"
                        className="checkbox checkbox-sm checkbox-primary"
                        checked={isChecked}
                        onChange={() => handleToggleAtleta(atleta)}
                      />
                      <span className="font-medium">{atleta.nome}</span>
                      {atleta.perfil && (
                        <span className="text-[11px] opacity-60 ml-auto">
                          {atleta.perfil}
                        </span>
                      )}
                    </label>
                  );
                })
              ) : (
                <div className="text-xs text-center py-2 opacity-60">
                  Nenhum atleta encontrado
                </div>
              )}
            </div>
          </div>

          <button
            onClick={handleEditProduct}
            className="w-full bg-green-500 hover:bg-green-800 text-white py-2 px-4 rounded-md mt-4"
          >
            Save Changes
          </button>
        </div>
      </div>

      {/* Aqui está a div para a imagem, abaixo do formulário */}
      <div className="container items-center max-w-lg shadow-lg rounded-lg p-5 bg-base-200 mt-4">
        <div className="avatar">
          <div className="w-[480px] h-[480px] ali">
            <img src={image} alt="Miniatura do Produto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
